'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var StyledThemeProvider = require('../../../providers/StyledThemeProvider.js');
var style = require('./style.js');
var index$1 = require('../../../components/Language/index.js');
require('../../../components/Spinner/index.js');
require('../../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/index.js');
require('../../../components/PudoCard/index.js');
require('../../../components/ItemCard/index.js');
require('../../../components/SelectItem/index.js');
require('../../../components/SelectList/index.js');
var index = require('../../../components/ErrorBanner/index.js');
var index$3 = require('../../../components/Footer/index.js');
var index$2 = require('../../../components/StickyFooter/index.js');
require('../../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/index.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/ItemCardSkeleton.js');
require('../../../components/Skeleton/LineItemSkeleton.js');
var PudoCardSkeleton = require('../../../components/Skeleton/PudoCardSkeleton.js');
var index$4 = require('../PudoCardList/index.js');
var index$5 = require('../LocationPickerList/index.js');
var index$6 = require('../HomePickupForm/index.js');
var helpers = require('./helpers.js');
var tokens = require('./tokens.js');
var pudoMethod = require('../../../transformers/pudoMethod.js');
var useLanguage = require('../../../hooks/useLanguage.js');
var style$1 = require('../PudoCardList/style.js');
var index$7 = require('../MultiLabelsForm/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PudoRawComponent = _ref => {
  var _selectedCategory$sel;
  let {
    error,
    loading,
    loadingLocations,
    pudoOptions: rawPudoOptions,
    selectedCategory,
    postalCode,
    postalCodeError,
    sortedBy,
    sortedByOptions,
    locations,
    headerTitle,
    returnAddress,
    preferencesStatus,
    locale,
    includeCurrency,
    showSkipLocation,
    showSwitchCategory,
    multiLabelsEnabled,
    labelsCount,
    labelsMax,
    progressiveStep,
    activeStep,
    onChange,
    onSubmit,
    onReset,
    onBack
  } = _ref;
  const {
    pudoDisplay
  } = nthHookSettings.useSettings();
  const {
    pudoOptionSort
  } = pudoDisplay ?? {};
  // You can affect the sort order of pudoOptions by setting pudoDisplay.pudoOptionSort in Quin.
  // This retailer setting uses an array of IDs generated using generatePudoId.
  // Pudo options not included in the pudoOptionSort or that don't match a given array item are sorted in retrieval
  // order at the end of the pudoOptions array.
  const pudoOptions = helpers.sortPudoOptions(rawPudoOptions, pudoOptionSort);
  const {
    rawValue: backLabel
  } = useLanguage["default"]({
    langKey: 'returnsActionsBack',
    asString: true
  });
  const {
    rawValue: nextLabel
  } = useLanguage["default"]({
    langKey: 'returnsActionsNext',
    asString: true
  });
  const selectedPudoOptionReference = pudoOptions === null || pudoOptions === void 0 ? void 0 : pudoOptions.find(pudoOption => pudoMethod.generatePudoId(pudoOption) === pudoMethod.generatePudoId(selectedCategory));
  const updatePayload = updates => {
    if (updates.newCategory) {
      const data = {
        pudoActionType: updates.newCategory.pudoActionType,
        pudoActionTypeDetails: updates.newCategory.pudoActionTypeDetails,
        pudoProvider: updates.newCategory.pudoProvider,
        title: updates.newCategory.title,
        description: updates.newCategory.description,
        fees: updates.newCategory.fees,
        serviceType: updates.newCategory.serviceType,
        discounts: updates.newCategory.discounts,
        narvarPudoInstructions: updates.newCategory.narvarPudoInstructions,
        selectedDropOff: updates.newDropOff,
        selectedPickup: updates.newPickup
      };
      return data;
    }
    return undefined;
  };
  const [isCategoryConfirmed, setIsCategoryConfirmed] = React.useState(false);
  const showMultiLabelsForm = isCategoryConfirmed && multiLabelsEnabled;
  const handleChangeCategory = value => {
    if (!value) {
      updatePayload({});
      if (selectedCategory) {
        onChange === null || onChange === void 0 ? void 0 : onChange({
          value: null,
          area: 'pudo',
          subComponent: 'category',
          event: 'change'
        });
      }
      onReset === null || onReset === void 0 ? void 0 : onReset({
        value: null,
        area: 'pudo',
        subComponent: 'category',
        event: 'reset'
      });
    }
    const categoryEvent = pudoOptions === null || pudoOptions === void 0 ? void 0 : pudoOptions.find(pudoOption => pudoMethod.generatePudoId(pudoOption) === value);
    if (categoryEvent) {
      var _categoryEvent$dropOf, _categoryEvent$dropOf2, _categoryEvent$dropOf3, _categoryEvent$pickup;
      const selectedLocation = categoryEvent === null || categoryEvent === void 0 ? void 0 : (_categoryEvent$dropOf = categoryEvent.dropOff) === null || _categoryEvent$dropOf === void 0 ? void 0 : (_categoryEvent$dropOf2 = _categoryEvent$dropOf.sortedLocations) === null || _categoryEvent$dropOf2 === void 0 ? void 0 : (_categoryEvent$dropOf3 = _categoryEvent$dropOf2.locationsList) === null || _categoryEvent$dropOf3 === void 0 ? void 0 : _categoryEvent$dropOf3[0];
      const data = updatePayload({
        newCategory: categoryEvent,
        newDropOff: selectedLocation && {
          selectedLocation: {
            id: selectedLocation.id
          }
        },
        newPickup: categoryEvent.pickup ? {
          selectedTimeSlot: categoryEvent.pickup.timeSlots[0],
          customerInstructions: '',
          selectedHandoff: (_categoryEvent$pickup = categoryEvent.pickup.handoffTypes) === null || _categoryEvent$pickup === void 0 ? void 0 : _categoryEvent$pickup[0]
        } : undefined
      });
      if (data) {
        onChange === null || onChange === void 0 ? void 0 : onChange({
          value: {
            selectedCategory: data
          },
          area: 'pudo',
          subComponent: 'category',
          event: 'change'
        });
      }
    }
  };
  const handleChangeLocation = value => {
    var _selectedPudoOptionRe, _selectedPudoOptionRe2, _selectedPudoOptionRe3;
    if (!selectedCategory) return;
    const selectedLocation = (locations === null || locations === void 0 ? void 0 : locations.find(_ref2 => {
      let {
        id
      } = _ref2;
      return id === value;
    })) || (selectedPudoOptionReference === null || selectedPudoOptionReference === void 0 ? void 0 : (_selectedPudoOptionRe = selectedPudoOptionReference.dropOff) === null || _selectedPudoOptionRe === void 0 ? void 0 : (_selectedPudoOptionRe2 = _selectedPudoOptionRe.sortedLocations) === null || _selectedPudoOptionRe2 === void 0 ? void 0 : (_selectedPudoOptionRe3 = _selectedPudoOptionRe2.locationsList) === null || _selectedPudoOptionRe3 === void 0 ? void 0 : _selectedPudoOptionRe3.find(_ref3 => {
      let {
        id
      } = _ref3;
      return id === value;
    }));
    const data = updatePayload({
      newCategory: selectedCategory,
      newDropOff: selectedLocation ? {
        selectedLocation: {
          id: selectedLocation.id
        }
      } : undefined
    });
    setIsCategoryConfirmed(false);
    if (data) {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        value: {
          selectedCategory: data
        },
        area: 'pudo',
        subComponent: 'location',
        event: 'change'
      });
      if (showSkipLocation && !selectedLocation) {
        handleNextEvent(data);
      }
    }
  };
  const handleChangePickupInstructions = pickup => {
    const data = updatePayload({
      newCategory: selectedCategory,
      newPickup: pickup
    });
    if (data) {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        value: {
          selectedCategory: data
        },
        area: 'pudo',
        subComponent: 'pickupInstructions',
        event: 'change'
      });
    }
  };
  const handleChangeHandoffType = pickup => {
    const data = updatePayload({
      newCategory: selectedCategory,
      newPickup: pickup
    });
    if (data) {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        value: {
          selectedCategory: data
        },
        area: 'pudo',
        subComponent: 'pickupHandoff',
        event: 'change'
      });
    }
  };
  const handleChangePickupTimeSlot = pickup => {
    const data = updatePayload({
      newCategory: selectedCategory,
      newPickup: pickup
    });
    if (data) {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        value: {
          selectedCategory: data
        },
        area: 'pudo',
        subComponent: 'pickupTimeslot',
        event: 'change'
      });
    }
  };
  const handleChangePostalCode = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: {
        postalCode: e
      },
      area: 'pudo',
      subComponent: 'postalCode',
      event: 'change'
    });
  };
  const handleChangeLabelsCount = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: {
        labelsCount: e
      },
      area: 'pudo',
      subComponent: 'multiLabels',
      event: 'change'
    });
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await
  const handleChangeSortedBy = async e => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: {
        sortedBy: e
      },
      event: 'change',
      area: 'pudo',
      subComponent: 'locationSort'
    });
  };
  const handleFooterEvent = event => {
    if (event.value === 'back') {
      setIsCategoryConfirmed(false);
      onBack === null || onBack === void 0 ? void 0 : onBack({
        area: 'pudo',
        subComponent: 'footer',
        event: 'back',
        value: null
      });
    }
    if (event.value === 'next') {
      handleNextEvent(selectedCategory);
    }
  };
  const handleNextEvent = selectedCategory => {
    if (multiLabelsEnabled && !isCategoryConfirmed) {
      setIsCategoryConfirmed(true);
    } else {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
        value: {
          selectedCategory
        },
        event: 'submit',
        area: 'pudo',
        subComponent: 'category'
      });
    }
  };
  if (loading) {
    return /*#__PURE__*/React__default["default"].createElement(style.Wrapper, null, /*#__PURE__*/React__default["default"].createElement(style.PudoElmWrap, null, /*#__PURE__*/React__default["default"].createElement(style$1.PudoGroup, null, /*#__PURE__*/React__default["default"].createElement(PudoCardSkeleton.PudoCardSkeleton, null), /*#__PURE__*/React__default["default"].createElement(PudoCardSkeleton.PudoCardSkeleton, null), /*#__PURE__*/React__default["default"].createElement(PudoCardSkeleton.PudoCardSkeleton, null), /*#__PURE__*/React__default["default"].createElement(PudoCardSkeleton.PudoCardSkeleton, null))));
  }
  if (pudoOptions && pudoOptions.length === 0 || error) {
    return /*#__PURE__*/React__default["default"].createElement(style.Wrapper, null, /*#__PURE__*/React__default["default"].createElement(style.PudoElmWrap, null, /*#__PURE__*/React__default["default"].createElement(index["default"], null, /*#__PURE__*/React.isValidElement(error) ? error : /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      langKey: "returnsPudoErrorNopudooptions"
    }))), /*#__PURE__*/React__default["default"].createElement(index$2["default"], null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
      progressiveStep: progressiveStep,
      activeStep: activeStep,
      onEvent: handleFooterEvent,
      buttons: {
        leftButton: {
          type: 'back',
          label: backLabel,
          outline: true
        },
        rightButton: {
          type: 'next',
          label: nextLabel,
          disabled: true
        }
      }
    })));
  }
  return /*#__PURE__*/React__default["default"].createElement(style.Wrapper, null, pudoOptions && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(index$4["default"], {
    onValueChange: handleChangeCategory,
    defaultValue: selectedCategory,
    preferencesStatus: preferencesStatus,
    showSwitchCategory: showSwitchCategory,
    headerTitle,
    pudoOptions,
    locale,
    includeCurrency
  }), /*#__PURE__*/React__default["default"].createElement(index$5["default"], {
    selectedCategory: selectedCategory,
    sortedBy: sortedBy,
    sortedByOptions: sortedByOptions
    // TODO: refactor instead of disable
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    ,
    sortedByValueChange: handleChangeSortedBy,
    postalCode: postalCode,
    postalCodeError: postalCodeError,
    loading: loadingLocations,
    locations: locations,
    onValueChange: handleChangeLocation,
    postalCodeValueSubmit: handleChangePostalCode,
    defaultValue: (selectedCategory === null || selectedCategory === void 0 ? void 0 : (_selectedCategory$sel = selectedCategory.selectedDropOff) === null || _selectedCategory$sel === void 0 ? void 0 : _selectedCategory$sel.selectedLocation) || undefined,
    showSkip: showSkipLocation && !isCategoryConfirmed
  }), /*#__PURE__*/React__default["default"].createElement(index$6["default"], {
    onChangePickupInstructions: handleChangePickupInstructions,
    onChangeHandoffSelection: handleChangeHandoffType,
    onChangePickupTimeSlot: handleChangePickupTimeSlot,
    availablePickup: selectedPudoOptionReference === null || selectedPudoOptionReference === void 0 ? void 0 : selectedPudoOptionReference.pickup,
    selectedPickup: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.selectedPickup,
    address: returnAddress
  }), showMultiLabelsForm && /*#__PURE__*/React__default["default"].createElement(index$7["default"], {
    value: labelsCount,
    max: labelsMax,
    onChange: handleChangeLabelsCount
  })), /*#__PURE__*/React__default["default"].createElement(index$2["default"], null, /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    progressiveStep: progressiveStep,
    activeStep: activeStep,
    onEvent: handleFooterEvent,
    buttons: {
      leftButton: {
        type: 'back',
        label: backLabel,
        disabled: loading,
        outline: true
      },
      rightButton: {
        type: 'next',
        label: nextLabel,
        disabled: loading || loadingLocations || !!error || !!postalCodeError || helpers.isDisabled(selectedCategory, selectedPudoOptionReference, isCategoryConfirmed, multiLabelsEnabled, labelsCount)
      }
    }
  })));
};
const PudoRaw = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(StyledThemeProvider.withStyledThemeProvider(PudoRawComponent, {
  themeTokens: tokens.themeTokens
}), {
  translationKeys: tokens.translationKeys
}), {
  settingsRequested: `
      pudoDisplay {
        pudoOptionSort
      }
    `
});

exports.PudoRaw = PudoRaw;
exports.PudoRawComponent = PudoRawComponent;
